import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'
import { Grid } from 'components/grid'
import { H4 } from 'components/typography/heading'
import LabelBase from 'pages/documents/signing-status/label'
import MessageBase from 'components/message'
import Paragraph from 'components/typography/paragraph'
import { CaptionSmall as CaptionSmallBase } from 'components/typography/caption'

export const Wrapper = styled(Grid)`
    grid-template-areas:
        "heading label"
        "content content";
    grid-template-rows: 24px auto;
    grid-template-columns: 1fr auto;
    row-gap: 16px;

    margin-block-end: 40px;
    border: 1px solid var(--huma-color-border-default);
    border-radius: 8px;
    padding: 16px;
`

export const Heading = styled(H4)`
    grid-area: heading;
`

export const Label = styled(LabelBase)`
    grid-area: label;
    justify-self: end;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    grid-area: content;

    & > :last-child {
        margin-block-end: 0;
    }
`

export const Status = styled.div`
    display: flex;
    column-gap: 16px;
    align-items: flex-start;

    line-height: 24px;

    svg {
        ${svgStroke()}
    }

    &.error {
        svg {
            color: var(--huma-color-foreground-destructive);
        }
    }

    button {
        height: 24px;

        font-size: 14px;
    }
`

export const CaptionSmall = styled(CaptionSmallBase)`
    margin-block-end: 8px;
`

export const Note = styled(Paragraph)`
    align-self: flex-start;

    margin-block-start: -8px;
    border-radius: 0 16px 16px 16px;
    padding: 8px 16px;
    background-color: var(--huma-color-surface-minimal);
`

export const Message = styled(MessageBase)`
    margin-block-end: 0;
`

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    & > * {
        justify-content: center;
    }
`